<div class="banner d-lg-flex d-none">
  <h1 class="font-heading fw-bold text-uppercase">{{ 'events.page.title' | translate }}</h1>
</div>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container">
  <fgbcl-marketplace-list
    [isList]="true"
    [showSortBar]="false"
    [marketplaceItemTypes]="[3, 5]"
    [eventItemView]="true"
  ></fgbcl-marketplace-list>
</div>
